export class PublicLinks {
  static myRecord = "https://my-record.net/";

  static googlePlay =
    "https://play.google.com/store/apps/details?id=com.myrecord";
  static appStore = "https://apps.apple.com/us/app/my-record/id1608807802";
}
